export const stripQuery = (url: string | undefined): string | undefined => {
  if (!url) return url;
  const cut = url.search(/[?#]/);
  return cut === -1 ? url : url.slice(0, cut);
};
